<template>
  <a v-if="url && token"
      class="btn btn_action btn_grey btn_request_logy"
      :title="'Zobrazit detail v aplikaci Device Log Viewer' | translate"
      @click.stop.prevent="onClick()">
    <translate class="translate">Zobrazit detail v aplikaci Device Log Viewer</translate>
  </a>
</template>

<script>
export default {
  name: 'DeviceLogViewerButton',
  props: {
    url: String,
    macAddress: String,
    token: String,
  },
  methods: {
    onClick(){
      let finalUrl = this.url+ (this.macAddress ? '?var-device_mac='+this.macAddress : '?var-device_token='+this.token);
      let role = this.$_loggedUser_getRoleForSection('deviceLogViewer', 'read');
      finalUrl = finalUrl.replace('{dashboard_uid}', role === 'ALL' ? 'dlv-prod' : 'dlv-operator')

      window.open(finalUrl, '_blank');
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/devices/detail/DeviceLogViewerButton.vue